import jwtAxios from '@nxsys/services/axios';
import { endPoints } from '@nxsys/services/endpoints';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { UploadFileToS3Params, UploadFileToS3Response } from '../types';

export const uploadFileToS3 = createAsyncThunk<
UploadFileToS3Response,
  UploadFileToS3Params
>(
  'common/uploadFileToS3',
  async (params: UploadFileToS3Params, { rejectWithValue }) => {
    try {
      const { file } = params;
      const getSignedS3Response = await jwtAxios.get(endPoints.uploadFile, {
        params: {
          fileType: file?.type || 'common',
          fileExt: file?.name.split('.')?.length
            ? file?.name.split('.')[file?.name.split('.').length - 1]
            : 'none',
        },
      });
      const { url } = getSignedS3Response.data;
      const URL_URL_AWS = url.split('?')?.length ? url.split('?')[0] : '';
      if (!URL_URL_AWS) {
        throw new Error('Upload file failed, please try again!');
      }
      await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-Type': file.type,
        },
        body: file,
      });

      return {
        url: URL_URL_AWS,
        success: true,
      };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const commonActs = {
  uploadFileToS3,
};
